import { Movie } from '@/lib/api/types/api'

/**
 * 動画データの基本インターface
 * APIレスポンスとして受け取るデータ形式
 */
export interface MovieData extends Omit<Movie, 'id' | 'videoId' | 'videoType' | 'thumbnailUrl'> {
  id: number
  title: string
  description: string
  url: string
  movieType: number // 0: YouTube, 1: Vimeo
  movieId?: string
  params?: string
  thumbnail?: string
  thumbnailUrl?: string // 既存のMovie型との互換性
  iframeUrl?: string
}

/**
 * Redux storeの動画状態管理用インターface
 */
export interface MovieState {
  movies: MovieData[]
}

/**
 * 動画の種類を表す定数
 */
export const MOVIE_TYPE = {
  YOUTUBE: 0,
  VIMEO: 1,
} as const

export type MovieType = (typeof MOVIE_TYPE)[keyof typeof MOVIE_TYPE]
